import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { DBDepartment } from "@/lib/db-types";

/** VIB-2917: Sølvrevs avdelinger (Oslo, Bergen). */
export function useDepartments() {
  return useQuery({
    queryKey: ["departments"],
    queryFn: async (): Promise<DBDepartment[]> => {
      const { data, error } = await supabase
        .from("departments")
        .select("id, name, sort_order")
        .order("sort_order");
      if (error) throw error;
      return (data ?? []) as DBDepartment[];
    },
    staleTime: 5 * 60 * 1000,
  });
}
